import { render, staticRenderFns } from "./SendDocumentsPersonal.vue?vue&type=template&id=20b34bbe&scoped=true&"
import script from "./SendDocumentsPersonal.vue?vue&type=script&lang=ts&"
export * from "./SendDocumentsPersonal.vue?vue&type=script&lang=ts&"
import style0 from "./SendDocumentsPersonal.vue?vue&type=style&index=0&id=20b34bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b34bbe",
  null
  
)

export default component.exports